import type { SVGProps } from 'react';

const SvgKredly = (props: SVGProps<SVGSVGElement>) => (
	<svg version="1.1" fill='currentColor' id="Vrstva_1" x="0px" y="0px"
	viewBox="0 0 841.89 595.28" {...props}>
		<polygon points="584.83,297.63 584.84,297.64 584.55,297.35 "/>
		<polygon points="584.83,297.63 584.84,297.64 584.55,297.35 "/>
		<polygon points="584.84,297.64 641.33,297.64 641.33,297.64 584.84,297.64 584.55,297.35 448.21,161.01 426.68,182.51 
		428.2,184.04 428.16,184.08 541.71,297.64 426.78,412.57 426.67,412.47 448.26,434.22 584.83,297.65 "/>
		<polygon points="368.9,240.19 368.9,240.19 368.97,240.12 "/>
		<polygon points="393.97,161.3 393.68,161.01 393.68,161.01 "/>
		<polygon points="781.66,297.61 710.22,226.17 683.25,199.2 546.63,62.59 448.21,161.01 584.55,297.35 584.84,297.64 
		641.33,297.64 641.33,297.64 584.84,297.64 584.83,297.65 448.26,434.22 448.21,434.27 546.63,532.69 683.25,396.07 710.22,369.1 
		781.66,297.67 781.63,297.64 "/>
		<polygon points="541.71,297.64 428.16,184.08 428.12,184.11 "/>
		<polygon points="541.71,297.64 541.58,297.64 426.67,412.47 426.78,412.57 "/>
		<rect x="426.57" y="182.51" transform="matrix(0.7077 -0.7065 0.7065 0.7077 -4.2675 354.7513)" width="0.11" height="0.04"/>
		<polygon points="426.75,182.73 426.78,182.7 428.16,184.08 428.2,184.04 426.68,182.51 426.6,182.59 "/>
		<polygon points="428.12,184.11 426.75,182.73 426.6,182.59 426.57,182.56 426.64,182.48 426.63,182.47 368.97,240.12 
		368.9,240.19 311.64,297.44 313.21,299.01 313.21,299.01 311.84,297.64 314.58,297.64 313.21,299.01 426.67,412.47 541.58,297.64 
		541.71,297.64 "/>
		<rect x="427.43" y="182.43" transform="matrix(0.7069 -0.7073 0.7073 0.7069 -4.4323 356.1208)" width="0.04" height="1.95"/>
		<polygon points="311.84,297.64 313.21,299.01 314.58,297.64 "/>
		<polygon points="394.82,162.15 393.97,161.3 394.81,162.15 "/>
		<polygon points="393.64,160.97 356.93,197.75 393.68,161.01 "/>
		<polygon points="393.67,434.25 394.41,433.51 394.35,433.45 393.61,434.2 "/>
		<polygon points="258.95,298.3 259.27,298.3 259.11,298.14 "/>
		<polygon points="257.93,296.97 257.92,296.96 257.14,297.73 257.71,298.3 257.78,298.3 257.19,297.71 "/>
		<polygon points="393.57,434.23 393.63,434.29 393.67,434.25 393.61,434.2 "/>
		<polygon points="257.14,297.74 257.7,298.3 257.71,298.3 257.14,297.73 "/>
		<path d="M272.99,298.3l0.01-0.01l129.03-128.92l-7.22-7.22l-0.85-0.85l-0.29-0.29l-36.74,36.74l36.71-36.78l0.04,0.04
		l0,0l-98.42-98.42L158.64,199.2l-26.97,26.97l-71.44,71.44l0.03,0.03l-0.03,0.03l71.44,71.44l26.97,26.97l136.62,136.62l98.42-98.42
		l-0.01-0.01l-0.04,0.04l-0.06-0.06l0.04-0.04l0.75-0.75l6.85-6.85L273,298.31L272.99,298.3z M258.95,298.3l-0.59,0.59l-0.59-0.59
		h-0.06h-0.01l-0.56-0.56l0.01-0.01l0.78-0.78l0.01,0.01l1.18,1.18l0.16,0.16H258.95z"/>
		<polygon points="257.93,296.97 257.19,297.71 257.78,298.3 258.95,298.3 259.11,298.14 "/>
		<polygon points="258.36,298.89 258.95,298.3 257.78,298.3 "/>
	</svg>
);

export default SvgKredly;
